import axios from '../axios/axios';
import {
  NET_PREMIUM_DATA_REQUEST,
  NET_PREMIUM_DATA_SUCCESS,
  NET_PREMIUM_DATA_FAIL,
} from '../constants/dispOfNetPremiumConstant';

export const dispOfNetPremiumAction = () => async (dispatch) => {
  try {
    dispatch({ type: NET_PREMIUM_DATA_REQUEST });
    const { data } = await axios.post('/rpiq-form-fetch', {
      section: 'f1v1s25',
      form_id: localStorage.getItem('formId'),
    });

    dispatch({
      type: NET_PREMIUM_DATA_SUCCESS,
      payload: data,
    });
  } catch (error) {
    if (
      error?.response?.status === 401 ||
      error?.response?.detail === 'Not authenticated'
    ) {
      window.location.replace('/');
    }
    dispatch({
      type: NET_PREMIUM_DATA_FAIL,
      payload: error,
    });
  }
};
